import { useParams, useNavigate } from "react-router-dom";
import { IcButton, IcTypography } from "@ukic/react";
import { LIVE_BASE } from "../api";

/**
 * Full-bleed in-page Live view. Embeds the Worker `/live/:slug/*` reverse proxy
 * (SPEC §3.7) which fronts the device's OWRX+ (waterfall + audio over WS). The
 * iframe is same-origin with the SPA, so the Access cookie rides along and the
 * Worker injects the service token towards the device.
 */
export default function Live() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();

  if (!slug) {
    return <IcTypography variant="body">No device specified.</IcTypography>;
  }

  const src = `${LIVE_BASE}/live/${encodeURIComponent(slug)}/`;

  return (
    <div className="hl-page hl-stack">
      <div className="hl-row-between">
        <IcTypography variant="h3">Live · {slug}</IcTypography>
        <div className="hl-row">
          <IcButton variant="secondary" href={src} target="_blank">
            Open in new tab
          </IcButton>
          <IcButton variant="tertiary" onClick={() => navigate(-1)}>
            Back
          </IcButton>
        </div>
      </div>
      <iframe
        className="hl-live-frame"
        title={`OpenWebRX+ live view for ${slug}`}
        src={src}
        // OWRX+ needs script + WS; same-origin via the proxy so no sandbox lockdown.
        allow="autoplay; fullscreen"
      />
    </div>
  );
}
